export default __webpack_public_path__ + "static/media/BC_188_BC_R9008_tn.0f9f6886.jpg";